  import { createSlice } from "@reduxjs/toolkit";
import { MailRequestModel } from "types";


const initialState: MailRequestModel[] = [];

const mailRequestsSlice = createSlice({
  name: 'mailRequests',
  initialState,
  reducers: {
    setMailRequests: (_state, action: { payload: MailRequestModel[] }) => {
      return action.payload;
    },
  },
});

export const { setMailRequests } = mailRequestsSlice.actions;
export default mailRequestsSlice.reducer;
